/**
 * Протокол обмена между клиентом и сервером.
 *
 * Сервер — единственный источник правды о состоянии воспроизведения.
 * Клиент никогда не хранит «своё» состояние: он присылает намерение
 * (нажали play/pause/перемотку), сервер валидирует и рассылает всем
 * новое состояние, привязанное к серверным часам.
 */
export const AVATAR_FACES = ['?', '🐈', '🦊', '🐙', '🦉', '🐸', '👾', '🍿', '🌚'];
export const AVATAR_COLORS = ['#ff5fa2', '#a97bff', '#7ed9c4', '#e8ff59', '#ff8a4c'];
export const DEFAULT_ROOM_SETTINGS = {
    reactions: true,
    hideEnding: false,
    access: 'link',
    drawing: true,
    trailSeconds: 5,
    guestSeek: true,
    autoCatchUp: true,
    openRoom: true,
};
export const ERROR_MESSAGES_RU = {
    room_not_found: 'Комната не найдена. Проверьте ссылку.',
    room_closed: 'Комната закрыта.',
    room_full: 'В комнате уже максимум участников.',
    room_locked: 'Комната закрыта для новых участников. Попросите ведущего открыть её.',
    not_allowed: 'Управлять плеером может только ведущий.',
    seek_not_allowed: 'Перематывать может только ведущий.',
    bad_request: 'Некорректный запрос.',
    rate_limited: 'Слишком часто. Немного подождите.',
    upload_not_found: 'Загрузка не найдена или устарела.',
    upload_failed: 'Не удалось загрузить файл.',
    payload_too_large: 'Файл слишком большой.',
    telegram_required: 'Сначала войдите через телеграм.',
    telegram_off: 'Телеграм на этом сервере не подключён.',
    telegram_auth_failed: 'Телеграм не подтвердил вход. Попробуйте ещё раз.',
    sticker_pack_not_found: 'Такого набора стикеров нет. Проверьте ссылку.',
    internal: 'Внутренняя ошибка сервера.',
};
// ─────────────────────────── ограничения ───────────────────────────
export const LIMITS = {
    nicknameMaxLength: 32,
    chatMessageMaxLength: 1000,
    roomNameMaxLength: 64,
    /** Сколько последних сообщений отдаём при входе. */
    chatHistorySize: 100,
    maxParticipantsPerRoom: 50,
    /** Размер чанка при загрузке файла. */
    uploadChunkSize: 8 * 1024 * 1024,
    maxPlaybackRate: 2,
    minPlaybackRate: 0.25,
    /** Сколько точек допускаем в одном штрихе: длинный взмах прореживаем. */
    strokeMaxPoints: 400,
    /** Сколько штрихов держим в комнате — чтобы вошедший позже увидел то же. */
    strokeBufferSize: 200,
    /** Сколько реакций держим одновременно. */
    reactionBufferSize: 60,
    /** Реакция живёт на кадре столько же, сколько длится её всплытие. */
    reactionLifetimeMs: 4400,
    /** Границы «следа рисунка» в секундах. */
    minTrailSeconds: 1,
    maxTrailSeconds: 120,
};
//# sourceMappingURL=protocol.js.map